// Static site content / data

export const COMPANY = {
  name: "Cape Maclear Holdings",
  short: "CMHL",
  tagline: "Architects of Africa's Next Integrated Smart City",
  phone: "+265 998 73 30 60",
  email: "info@capemaclearholdings.com",
  address: "20 Castle Crescent, P.O. Box 350, Blantyre, Malawi",
  website: "www.capemaclearholdings.com",
  ceo: "Mr Bright Malopa",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About Us", testid: "nav-about" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/investor-relations", label: "Investor Relations", testid: "nav-investors" },
  { to: "https://10dmedia.online/books/hvsw/", label: "Company Profile", testid: "nav-profile", external: true },
  { to: "/contact", label: "Contact Us", testid: "nav-contact" },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/tofoqejc_1.png";

export const INVESTOR_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/smgzqdw2_WhatsApp%20Video%202026-05-19%20at%207.45.29%20PM.mp4";

export const TEAM = {
  cmhl: [
    { name: "Bright Malopa", title: "Chief Executive Officer", org: "Cape Maclear Holdings Ltd" },
    { name: "Teddie Chanza", title: "Chief Commercial Officer", org: "Cape Maclear Holdings Ltd" },
    { name: "Bernard Omenda", title: "Head of Treasury", org: "Cape Maclear Holdings Ltd" },
    { name: "Ben Chitsonga", title: "Head of Admin & Accounting", org: "Cape Maclear Holdings Ltd" },
    { name: "George Ajjasi", title: "Chief Risk & Compliance Officer", org: "Cape Maclear Holdings Ltd" },
    { name: "Prof. Mpalive Msiska", title: "Head of Education Hub", org: "Cape Maclear Holdings Ltd" },
  ],
  ae7: [
    { name: "Hani Shammah, PhD, LLM", title: "Chief Executive Officer", org: "AE7 Dev. Mgmt. Africa" },
    { name: "John Kim", title: "Head of Design Management", org: "AE7 Dev. Mgmt. Africa" },
    { name: "Imad Mroueh", title: "Head of Eng. & Construction", org: "AE7 Dev. Mgmt. Africa" },
    { name: "Georges Girgis", title: "Project Mgmt. Coordination Head", org: "AE7 Dev. Mgmt. Africa" },
    { name: "Martin Benkenstein", title: "Regional Business Development", org: "AE7 Dev. Mgmt. Africa" },
    { name: "Hugo Pipa", title: "Director of Masterplanning", org: "AE7" },
  ],
};

export const HERO_SLIDES = [
  {
    url: "https://images.unsplash.com/photo-1715948889156-8e7b1ee20231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxMYWtlJTIwTWFsYXdpfGVufDB8fHx8MTc3NzU4NzI0MXww&ixlib=rb-4.1.0&q=85",
    overline: "Cape Maclear Special Economic Zone",
    title: "Where the Lake of Stars\nMeets the Future of Africa",
    body: "A USD 3.5 billion master development transforming Mangochi into a world-class hub — anchored by an international airport, an International Financial Centre, luxury hotels, wellness resorts and sustainable living.",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/vanq31jj_2.png",
    overline: "Smart City Infrastructure",
    title: "An Integrated City Ecosystem,\nEngineered for a New Century",
    body: "Fibre, power, transit and an International Financial Centre — delivered to global standards, designed for the African continent.",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/az19r6it_3.png",
    overline: "Airport · Logistics · Aviation",
    title: "Three Hours From\n23 African Nations",
    body: "A new international airport and logistics spine connecting a 577M+ regional market and a $928B+ combined GDP — business, tourism and trade, seamlessly linked.",
  },
];

export const STATS = [
  { value: 3.5, prefix: "USD $", suffix: "B", label: "Master Development", testid: "stat-investment" },
  { value: 49000, suffix: "+", label: "Job Opportunities", testid: "stat-jobs" },
  { value: 577, suffix: "M+", label: "Regional Population", testid: "stat-population" },
  { value: 23, suffix: "", label: "Countries Within 3-Hr Flight", testid: "stat-countries" },
];

export const SERVICES = [
  {
    key: "smart-city",
    title: "Smart City Infrastructure",
    summary: "An integrated smart city — fibre, digital backbone, roads and utilities — anchoring an International Financial Centre, business district, hotels and residential quarters.",
    image: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/vanq31jj_2.png",
    icon: "Building2",
  },
  {
    key: "tourism",
    title: "Tourism, Hotels & Wellness",
    summary: "A premier lakeside destination — five-star hotels, wellness retreats, spa resorts, conferencing and Malawian cultural experience, all on the shores of Lake Malawi.",
    image: "https://images.unsplash.com/photo-1667543889074-c625970dacff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxDYXBlJTIwTWFjbGVhcnxlbnwwfHx8fDE3Nzc1ODcyNDF8MA&ixlib=rb-4.1.0&q=85",
    icon: "Palmtree",
  },
  {
    key: "logistics",
    title: "Airport, Logistics & Aviation",
    summary: "A new international airport and logistics backbone — moving goods, investors and visitors efficiently between Cape Maclear and 23 nations across the African continent.",
    image: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/az19r6it_3.png",
    icon: "Plane",
  },
  {
    key: "agri-industrial",
    title: "Agriculture & Industry",
    summary: "Modern agricultural value-chains, agro-processing and light industrial parks that lift regional food security and unlock export-grade output.",
    image: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/1ummsupk_4.png",
    icon: "Wheat",
  },
  {
    key: "energy",
    title: "Renewable Energy",
    summary: "Solar, hydro and hybrid renewable systems — the clean power backbone of an environmentally responsible, future-proof city.",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1600&q=80",
    icon: "Sun",
  },
  {
    key: "economic",
    title: "Economic Development",
    summary: "An International Financial Centre, mixed-use real estate and large-scale construction — driving jobs, skills transfer and shared prosperity across the region.",
    image: "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/ndw5erxd_5.png",
    icon: "TrendingUp",
  },
];

export const VALUES = [
  { title: "Excellence", body: "A relentless commitment to global standards in every layer of the development." },
  { title: "Innovation", body: "Forward-thinking models that redefine how African cities are planned and built." },
  { title: "Sustainability", body: "Renewable energy, smart planning, and an environmentally conscious footprint." },
  { title: "Inclusivity", body: "Shared prosperity — for local communities, regional partners and global investors." },
  { title: "Partnership", body: "Collaborative delivery with global development firms and strategic stakeholders." },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1715948889156-8e7b1ee20231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxMYWtlJTIwTWFsYXdpfGVufDB8fHx8MTc3NzU4NzI0MXww&ixlib=rb-4.1.0&q=85",
    caption: "Lake Malawi — Hills & Shore",
  },
  {
    url: "https://images.unsplash.com/photo-1658221744192-00e3770b8625?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxMYWtlJTIwTWFsYXdpfGVufDB8fHx8MTc3NzU4NzI0MXww&ixlib=rb-4.1.0&q=85",
    caption: "Artisanal Fishing at Dawn",
  },
  {
    url: "https://images.unsplash.com/photo-1715948887678-f33850e4ac50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxMYWtlJTIwTWFsYXdpfGVufDB8fHx8MTc3NzU4NzI0MXww&ixlib=rb-4.1.0&q=85",
    caption: "Granite Boulders, Cape Maclear",
  },
  {
    url: "https://images.unsplash.com/photo-1667543889074-c625970dacff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxDYXBlJTIwTWFjbGVhcnxlbnwwfHx8fDE3Nzc1ODcyNDF8MA&ixlib=rb-4.1.0&q=85",
    caption: "Cape Maclear Shoreline",
  },
  {
    url: "https://images.unsplash.com/photo-1559038241-a7851fa59467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxMYWtlJTIwTWFsYXdpfGVufDB8fHx8MTc3NzU4NzI0MXww&ixlib=rb-4.1.0&q=85",
    caption: "Lake of Stars Horizon",
  },
  {
    url: "https://images.unsplash.com/photo-1758640098400-061795902273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzbWFydCUyMGNpdHklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3NTg3MjQxfDA&ixlib=rb-4.1.0&q=85",
    caption: "The Master-Planned Vision",
  },
];
